import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center pt-20 pb-12 px-4 overflow-hidden" data-id="element-56">
      {/* Background Image with Cinematic Scrim */}
      <div className="absolute inset-0 z-0" data-id="element-57">
        <img src="https://cdn.magicpatterns.com/uploads/w4tzeMYujDbs59SSCcUnmR/banner_asado.jpg" alt="Asado Chileno" className="w-full h-full object-cover object-center" data-id="element-58" />
        <div className="absolute inset-0 bg-gradient-to-b from-bbq-dark/80 via-bbq-dark/70 to-bbq-dark" data-id="element-59"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(13,11,10,0.8)_100%)]" data-id="element-60"></div>
      </div>

      {/* Header Logo */}
      <div className="absolute top-0 left-0 w-full p-6 z-20 flex justify-center" data-id="element-61">
        <img src="https://cdn.magicpatterns.com/uploads/5N168WCMoDKJb6bRLWfvc8/logo_asado.png" alt="Logo Asado" className="h-16 md:h-20 object-contain drop-shadow-2xl opacity-90" data-id="element-62" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center mt-12" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-64">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-display font-bold text-white leading-[1.1] tracking-tight uppercase mb-6 drop-shadow-2xl" data-id="element-65">
            Cómo transformar a tu Papá en un{' '}
            <span className="text-bbq-ember" data-id="element-66">"Maestro Parrillero"</span> en
            menos de 30 días
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 font-medium mb-8 max-w-3xl mx-auto drop-shadow-lg" data-id="element-67">
            — Incluso si siempre termina quemando la carne o sirviéndola como un
            zapato.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="bg-bbq-surface/60 backdrop-blur-sm border border-white/10 p-6 md:p-8 rounded-xl max-w-2xl mx-auto mb-10" data-id="element-68">
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-69">
            El regalo digital de entrega inmediata que salvará los próximos 100
            domingos familiares.{' '}
            <strong className="text-bbq-gold font-semibold" data-id="element-70">
              Sin pagar envíos, sin esperas y sin regalar lo mismo de siempre.
            </strong>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-71">
          <button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-bbq-ember hover:bg-bbq-ember-dark text-white font-display text-xl md:text-2xl uppercase tracking-wider py-4 px-10 rounded-sm transition-all duration-300 shadow-[0_0_30px_rgba(232,98,45,0.3)] hover:shadow-[0_0_40px_rgba(232,98,45,0.5)] transform hover:-translate-y-1" data-id="element-72">
            Ver Oferta del Día del Padre
          </button>
        </motion.div>
      </div>

      <motion.div className="absolute bottom-8 text-white/50 animate-bounce cursor-pointer z-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} onClick={() => document.getElementById('hook')?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-73">
        <ChevronDown size={32} data-id="element-74" />
      </motion.div>
    </section>;
}